"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _InteractiveChatMessages = require("../InteractiveChatMessages.styled");
var ScrollButton = exports.ScrollButton = function ScrollButton(_ref) {
  var onJumpToLatest = _ref.onJumpToLatest;
  return _react["default"].createElement("section", {
    className: "jump-to-latest"
  }, _react["default"].createElement(_InteractiveChatMessages.JumpToLatest, {
    "data-testid": "jump-to-latest",
    onClick: onJumpToLatest
  }, _react["default"].createElement(_InteractiveChatMessages.StyledArrowIcon, {
    icon: _freeSolidSvgIcons.faArrowCircleDown
  }), "See latest"));
};